import { useEffect, useState } from 'react';

const isDev = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return (
    window?.location?.hostname === 'localhost' ||
    window?.location?.hostname?.startsWith('admin')
  );
};

interface DevInfoProps {
  children: React.ReactNode;
}

export const DevInfo: React.FC<DevInfoProps> = ({ children }: DevInfoProps) => {
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    setShow(isDev());
  }, []);

  return show ? <>{children}</> : null;
};
